module.exports = __webpack_public_path__ + "static/img/partImageOne.4b014fa.jpg";